import { useActiveUnit } from "components/Unit";
import { atom, useAtom } from "jotai";

const isOpenContactDrawer = atom(false);
const contactDrawerUnit = atom(null);

const useContactDrawer = () => {
  const [isOpen, setIsOpen] = useAtom(isOpenContactDrawer);

  const unit = useActiveUnit();

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const open = (unit) => {
    setIsOpen(true);
  };

  return { toggle, open, isOpen, unit };
};

export { useContactDrawer };
